import namespace from '@/store/namespace'
export default namespace('PromocionesEmpresariales',{
    getters:[
        'GetdatosPe',
        'GetlugarDesarrollo',
        'Getpromociones',
        'GetPromocionesEnviadasNetTodos',
        'GetPromocionesNet'
    ],
    actions:[
        'RegistrarPromocionEmpresarial',
        'ModificarPromocionEmpresarial',
        'ObtenerPromocionEmpresarialFiltro',
        'ObtenerPromocionesTodosNet',
        'ObtenerPromocionesNet',
        'ObtenerPromocionEmpresarial',
        'ObtenerPromocionEmpresarialxTramiteId',
        'ClonarPeEnviadaSolicitudNueva',
        'MigrarPromocionFisicayPajelv1',
        'Obtenernotificaciones',
        'Obteneravisos',
        'ObteneravisosLista',
        'ObtenerPromocion',
        'ActualizarAviso',
        'ObtenerDatosPromocion',
        'ObtenerPromocionEmpresarialxTramiteIdV2',
        'ObtenerLugarEntregaPremioNet',
        'ObtenerMecanicaNet'


    ],
    mutations:[
        'SetdatosPe',
        'SetlugarDesarrollo',
        'Setpromociones',
        'SetPromocionesEnviadasNetTodos',
        'SetPromocionesNet'
    ]
})